module.exports = __webpack_public_path__ + "img/icon-indo.17c52e05.png";